var React = require('react');

function Youtube (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M22.358,3.21C18.25,2.929,9.1,2.93,5,3.21.556,3.513.033,6.2,0,13.259.033,20.308.552,23,5,23.307c4.1.279,13.252.28,17.36,0,4.442-.3,4.965-2.986,5-10.049C27.323,6.209,26.8,3.514,22.358,3.21Zm-12.1,14.608V8.7l9.119,4.551Z","transform":"translate(0 -3)","fill":"#fff"}));
}

Youtube.defaultProps = {"viewBox":"0 0 27.356 20.517"};

module.exports = Youtube;

Youtube.default = Youtube;
